import { CommonService } from './../../../services/common/common.service';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { QuoteOrderService } from '../../../services/quote-order/quote-order.service';
import { LoaderService } from '../../../services/infrastructure/loader.service';
import { MatDialog } from '@angular/material/dialog';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { LocalStorageService } from '../../../services/infrastructure/local-storage.service';
import { MasterConstants } from '../../../common/constants/master-constants';
import { ConfirmDialogComponent } from '../../../common/components/confirm-dialog/confirm-dialog.component';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { LolLoggerService } from '../../../common/shared/lol-logger.service';

@Component({
  selector: 'app-view-quote-details',
  templateUrl: './view-quote-details.component.html',
  styleUrls: ['./view-quote-details.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0', display: 'none' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
    trigger('fadeInOut', [
      transition(':enter', [   // :enter is alias to 'void => *'
        style({ opacity: 0 }),
        animate(400, style({ height: '0px', opacity: 1 }))
      ]),
      transition(':leave', [   // :leave is alias to '* => void'
        animate(400, style({ height: '0px', opacity: 0 }))
      ])
    ])
  ]
})
export class ViewQuoteDetailsComponent implements OnInit, OnDestroy {
  private subscription = new Array<Subscription>();

  quoteid: number;
  quoteNumber: any;
  quoteDetail: any;
  quoteItemList: any;
  preparedFor: string;
  isQuoteExpire: boolean;
  quoteStatus: string;
  displayedHeaderTableCol: string[] = ['account', 'status', 'quoteDate', 'closeDate', 'preparedBy', 'preparedFor', 'approvedBy', 'approvalDate', 'detail'];
  displayedColumns: string[] = ['product', 'detail', 'quoteQty', 'releaseQty', 'remainingQty', 'orderUOM', 'priceUOM', 'qtyInPriceUOM', 'paymentTerms', 'requestedDeliveryDate'];
  plAccess = false;

  isApproveRejectAccess = false;
  isCreateSalesOrderAccess = false;
  isReviewSalesOrderAccess = false;
  isSubmitToFulfillmentAccess = false;
  isCloseQuoteAccess = false;
  isQuoteApproveAccess = false;
  isQuoteClosed = false;
  hasNoRemainingQty = false;
  expendedVar = false;
  constructor(private activatedRoute: ActivatedRoute,
    private quoteOrderService: QuoteOrderService,
    private loaderService: LoaderService,
    private localStorageService: LocalStorageService,
    private toastrService: ToastrService,
    private commonService: CommonService,
    private matDialog: MatDialog,
    private router: Router) { }

  ngOnInit() {
    if (this.localStorageService.get(MasterConstants.EVOLVE_ACCESS)) {
      const data = JSON.parse(this.localStorageService.get(MasterConstants.EVOLVE_ACCESS));
      if (data !== null && data !== undefined && data.resultData.length > 0) {
        const userMenuAccessList = data.resultData.find(x => x.userIdCompanyCode == JSON.parse(this.localStorageService.get(MasterConstants.HEADER_COMPANY_CODE))).userMenuAccessList;
        if (userMenuAccessList && userMenuAccessList.length > 0) {
          if (this.commonService.checkUserRoleAccessTypeForMenu(userMenuAccessList, MasterConstants.FUNCTION_CODE.CROP_PROTECTION_PRODUCT_PRICE_LIST)) {
            this.plAccess = true;
            this.displayedColumns = ['product', 'detail', 'quoteQty', 'releaseQty', 'remainingQty', 'orderUOM', 'unitPrice', 'priceUOM', 'qtyInPriceUOM', 'paymentTerms', 'requestedDeliveryDate'];
          }
          this.isCloseQuoteAccess = this.commonService.checkUserRoleAccessType(MasterConstants.FUNCTION_CODE.QUOTE_CLOSE_PERMISSION, MasterConstants.USER_ACCESS.EDIT_FULL, userMenuAccessList);
          this.isQuoteApproveAccess = this.commonService.checkUserRoleAccessType(MasterConstants.FUNCTION_CODE.QUOTE_APPROVE_OR_REJECT_PERMISSION, MasterConstants.USER_ACCESS.EDIT_FULL, userMenuAccessList);
        }
      }
    }

    this.subscription.push(this.activatedRoute.paramMap.subscribe(params => {
      if ((params.get('quoteNumber')) != undefined) {
        this.quoteNumber = (params.get('quoteNumber'));
      }
    }));
    this.getViewQuoteDetail();
  }

  getViewQuoteDetail() {
    this.loaderService.setLoaderStatus(true);

    this.subscription.push(this.quoteOrderService.getQuoteOrderDetail(this.quoteNumber).subscribe(result => {
      this.quoteDetail = new Array(result);
      this.quoteItemList = result.quoteItems;
      this.quoteid = result.quoteID;
      this.preparedFor = result.preparedFor;
      this.isQuoteExpire = result.isQuoteExpire;
      this.quoteStatus = result.status.toUpperCase();
      this.validateAllAccess(result.status);

      this.quoteItemList.map(x => {
        x.hasError = false;
        x.lineLevelError = [];
        return x;
      });

      // disable submit button if there is any remaining qty
      if (!this.quoteItemList.some(x => (x.quoteQty - x.releaseQty) > 0)) {
        this.hasNoRemainingQty = true;
      }

      this.loaderService.setLoaderStatus(false);
    }, error => this.loaderService.setLoaderStatus(false)));
  }

  showProductDetails(item) {
    item.isDetailDisplayed = !item.isDetailDisplayed;
  }

  showComments(item) {
    this.expendedVar = !this.expendedVar;
    item.isDetailDisplayed = !item.isDetailDisplayed;
  }

  validateAllAccess(status) {
    this.isApproveRejectAccess = false;
    this.isCreateSalesOrderAccess = false;
    this.isSubmitToFulfillmentAccess = false;
    this.isReviewSalesOrderAccess = false;
    this.isQuoteClosed = false;

    // Validate Approve/Reject
    if (status != null && status.toUpperCase() == 'OPEN' && this.plAccess) {
      this.isApproveRejectAccess = true;
    }

    // Validate Create Sales Order and Submit Sales Order(s) for Fulfillment
    if (status != null && (status.toUpperCase() == 'APPROVED' || status.toUpperCase() == 'APPROVED WITH EXCEPTION')) {
      this.isCreateSalesOrderAccess = true;
      this.isSubmitToFulfillmentAccess = true;
    }

    // Validate Review Sales Orders
    if (status != null && (status.toUpperCase() == 'APPROVED' ||
      status.toUpperCase() == 'APPROVED WITH EXCEPTION' ||
      status.toUpperCase() == 'CLOSED')) {
      this.isReviewSalesOrderAccess = true;
    }

    if (status.toUpperCase() != 'CLOSED') {
      this.isQuoteClosed = true;
    }
  }

  approveOrRejectQuote() {
    const dialogRef = this.matDialog.open(ConfirmDialogComponent, {
      disableClose: true,
      width: '400px',
      height: '280px',
      data: { title: 'Approve Or Reject Quote', quoteNumber: this.quoteNumber, preparedFor: this.preparedFor, labelYes: 'Yes', labelNo: 'No', dialogType: 'quoteOrderApproveOrReject' }
    });

    this.subscription.push(dialogRef.afterClosed().subscribe(result => {
      if (result != null && result != undefined && result != '') {
        this.loaderService.setLoaderStatus(true);
        result.comments = result.comments == undefined ? '' : result.comments;

        this.subscription.push(this.quoteOrderService.approveOrRejectQuote(this.quoteNumber, result.comments, result.status).subscribe(result => {
          this.getViewQuoteDetail();
          this.loaderService.setLoaderStatus(false);
        }, error => this.loaderService.setLoaderStatus(false)));
      }
    }));
  }

  createQuoteOrder() {
    this.quoteOrderService.setQuoteId(this.quoteid);
    this.router.navigate(['/quote/create-quote-order']);
  }

  reviewSalesOrder() {
    this.quoteOrderService.setQuoteId(this.quoteid);
    this.router.navigate(['/quote/view-quote-order']);
  }

  redirectToLanding() {
    this.router.navigate(['/cpp/landing-data']);
    this.commonService.currentTabIndex.next(2);
  }

  submitSalesOrder() {
    this.isSubmitToFulfillmentAccess = false;
    const saveObj: any = {};
    saveObj.quoteId = this.quoteid;

    this.loaderService.setLoaderStatus(true);

    // remove old messages if any
    this.quoteItemList.map(x => {
      x.hasError = false;
      x.lineLevelError = [];
      return x;
    });

    this.subscription.push(this.quoteOrderService.submitSalesOrder(saveObj).subscribe((result: any) => {
      if (result) {
        const errorResult = result.filter(x => x.errors.length > 0);
        const lineLevelError = result[0].lineLevelErrors;
        if ((errorResult && errorResult.length > 0) || (lineLevelError && lineLevelError.length > 0)) {
          // show error messages
          errorResult.forEach(d => {
            d.errors.forEach(e => {
              this.toastrService.error(e);
            });
          });

          lineLevelError.forEach(er => {
            this.quoteItemList.filter(x => x.quoteItemId == er.quoteItemId).map(x => {
              x.hasError = true;
              x.lineLevelError.push(er.errorMessage);
              return x;
            });
          });

          this.isSubmitToFulfillmentAccess = true;
        }
        else {
          this.quoteOrderService.setQuoteId(this.quoteid);
          this.router.navigate(['/quote/quote-order-summary']);
        }

        this.loaderService.setLoaderStatus(false);
      }
    }, (error) => {
      this.isSubmitToFulfillmentAccess = true;
      this.loaderService.setLoaderStatus(false);
      this.toastrService.error('Order not saved in the system.');
      LolLoggerService.error(error);
    }));
  }

  closeQuote() {
    this.loaderService.setLoaderStatus(true);

    this.subscription.push(this.quoteOrderService.closeQuote(this.quoteNumber).subscribe(result => {
      this.getViewQuoteDetail();
      this.loaderService.setLoaderStatus(false);
    }, error => this.loaderService.setLoaderStatus(false)));
  }

  public ngOnDestroy(): void {
    this.subscription.forEach(subscription => subscription.unsubscribe());
  }
}
